// purchaseReturnActions.js
import { purchaseReturnAPI } from './api';

export const purchaseReturnActions = {
// Get purchases by supplier for returns
getPurchasesBySupplier: async (supplierId) => {
  try {
    const response = await purchaseReturnAPI.getPurchasesBySupplier(supplierId);
    console.log('API Response for purchases:', response.data);
    if (response.data ) {
      // Return the FULL data object from API, not just purchases
      return {
        success: true,
        data: response.data || {
          purchases: response.data.purchases || [],
          total: response.data.total || 0,
          supplier: response.data.supplier,
          debug: response.data.debug
        },
        message: response.data.message || 'Purchases fetched successfully'
      };
    } else {
      return {
        success: false,
        data: [],
        message: response.data?.message || 'No purchases found'
      };
    }
  } catch (error) {
    console.error('Error fetching purchases by supplier:', error);
    console.error('Error details:', error.response?.data);
    return {
      success: false,
      data: [],
      message: error.response?.data?.message || 'Failed to fetch purchases'
    };
  }
},

// Get purchase items for return
getPurchaseItems: async (purchaseId) => {
  try {
    const response = await purchaseReturnAPI.getPurchaseItems(purchaseId);
    console.log('API Response for items:', response.data);
    if (response.data ) {
      // Return the FULL data object from API, not just items
      return {
        success: true,
        data: response.data || {
          purchase: response.data.purchase,
          items: response.data.items || [],
          returnable_items: response.data.returnable_items || [],
          total_items: response.data.total_items || 0,
          returnable_count: response.data.returnable_count || 0
        },
        message: response.data.message || 'Items fetched successfully'
      };
    } else {
      return {
        success: false,
        data: [],
        message: response.data?.message || 'No items found'
      };
    }
  } catch (error) {
    console.error('Error fetching purchase items:', error);
    console.error('Error details:', error.response?.data);
    return {
      success: false,
      data: [],
      message: error.response?.data?.message || 'Failed to fetch items'
    };
  }
},

  // Create purchase return
  createReturn: async (returnData) => {
    try {
      // Validate required fields
      if (!returnData.purchase_id) {
        return { success: false, message: 'Purchase ID is required' };
      }
      
      if (!returnData.supplier_id) {
        return { success: false, message: 'Supplier is required' };
      }
      
      if (!returnData.items || returnData.items.length === 0) {
        return { success: false, message: 'At least one return item is required' };
      }
      
      const response = await purchaseReturnAPI.create(returnData);
      if (response.data ) {
        return {
          success: true,
          data: response.data || response.data,
          message: response.data.message || 'Purchase return created successfully'
        };
      } else {
        return {
          success: false,
          message: response.data?.message || 'Failed to create purchase return'
        };
      }
    } catch (error) {
      console.error('Error creating purchase return:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create purchase return'
      };
    }
  },

  // Get purchase returns list
  getReturns: async (params = {}) => {
    try {
      const response = await purchaseReturnAPI.list(params);
      if (response.data ) {
        return {
          success: true,
          data: response.data.returns || [],
          total: response.data.total || 0,
          page: response.data.page || 1,
          totalPages: response.data.total_pages || 1
        };
      } else {
        return {
          success: false,
          data: [],
          message: response.data?.message || 'No returns found'
        };
      }
    } catch (error) {
      console.error('Error fetching purchase returns:', error);
      return {
        success: false,
        data: [],
        message: error.response?.data?.message || 'Failed to fetch returns'
      };
    }
  },

  // Get single purchase return
  getReturn: async (id) => {
    try {
      const response = await purchaseReturnAPI.get(id);
      if (response.data ) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          message: response.data?.message || 'Return not found'
        };
      }
    } catch (error) {
      console.error('Error fetching purchase return:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch return'
      };
    }
  },

  // Update purchase return
  updateReturn: async (id, returnData) => {
    try {
      const response = await purchaseReturnAPI.update(id, returnData);
      
      if (response.data ) {
        return {
          success: true,
          data: response.data || response.data,
          message: response.data.message || 'Purchase return updated successfully'
        };
      } else {
        return {
          success: false,
          message: response.data?.message || 'Failed to update purchase return'
        };
      }
    } catch (error) {
      console.error('Error updating purchase return:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update return'
      };
    }
  },

  // Delete purchase return (only if pending)
  deleteReturn: async (id) => {
    try {
      const response = await purchaseReturnAPI.delete(id);
      
      if (response.data) {
        return {
          success: true,
          data: response.data.data || response.data,
          message: response.data.message || 'Purchase return deleted successfully'
        };
      } else {
        return {
          success: false,
          message: response.data?.message || 'Failed to delete purchase return'
        };
      }
    } catch (error) {
      console.error('Error deleting purchase return:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete return'
      };
    }
  },

  // Create supplier credit from return
  createSupplierCredit: async (returnId) => {
    try {
      const response = await purchaseReturnAPI.createCredit(returnId);
      
      if (response.data ) {
        return {
          success: true,
          data: response.data.data || response.data,
          message: response.data.message || 'Supplier credit created successfully'
        };
      } else {
        return {
          success: false,
          message: response.data?.message || 'Failed to create supplier credit'
        };
      }
    } catch (error) {
      console.error('Error creating supplier credit:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create credit'
      };
    }
  },

 // Adjust stock based on return status
adjustStock: async (returnId, adjustmentData) => {
  try {
    const response = await purchaseReturnAPI.adjustStock(returnId, adjustmentData);
    if (response.data.success) {
      return {
        success: true,
        message: 'Stock adjusted successfully'
      };
    } else {
      return {
        success: false,
        message: response.data.message || 'Failed to adjust stock'
      };
    }
  } catch (error) {
    console.error('Error adjusting stock:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to adjust stock'
    };
  }
},
 // Reverse stock adjustment
reverseStockAdjustment: async (returnId) => {
  try {
    const response = await purchaseReturnAPI.reverseStockAdjustment(returnId);
    if (response.data.success) {
      return {
        success: true,
        message: 'Stock adjustment reversed successfully'
      };
    } else {
      return {
        success: false,
        message: response.data.message || 'Failed to reverse stock adjustment'
      };
    }
  } catch (error) {
    console.error('Error reversing stock adjustment:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to reverse stock adjustment'
    };
  }
}
};
